import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Table, Row, Col, Form, Pagination, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom';
import { var_api } from '../../constant';
import Swal from "sweetalert2";

const ClientSummaryList = () => {
  const [clientsData, setClientsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const history = useHistory();

  useEffect(() => {
    fetchClientSummary();
  }, [startDate, endDate]);

  function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  }

  const fetchClientSummary = async () => {
    try {
      const token = localStorage.getItem('token');
      // const userId = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const response = await axios.get(
        `${var_api}/api/booking/get-clients-summary/${formattedStartDate}/${formattedEndDate}`,
        { headers: { Authorization: `${token}` } }
      );
      setClientsData(response.data);
      setPopupLast30Days(false);
    } catch (error) {
      console.error("Error fetching clients:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredClients = clientsData.filter((client) => {
    const name = client.name?.toLowerCase() || '';
    const email = client.email_id?.toLowerCase() || '';
    const location = client.address_location?.toLowerCase() || '';
    const country = client.country_name?.toLowerCase() || '';
    const referral = client.customer_referal?.toLowerCase() || '';
    return (
      name.includes(searchQuery.toLowerCase()) ||
      email.includes(searchQuery.toLowerCase()) ||
      location.includes(searchQuery.toLowerCase()) ||
      country.includes(searchQuery.toLowerCase()) ||
      referral.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredClients.length / pageSize);
  const paginatedClients = filteredClients.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const exportToExcel = () => {
    const data = paginatedClients.map((client, index) => ({
      'S.No': index + 1,
      'Name': client.name,
      'Mobile No': client.mobile_no,
      'Email': client.email_id,
      'Location': client.address_location,
      'Country': client.country_name,
      'Referral': client.customer_referal,
      'Last Appointment': formatDate(client.last_appointment_date),
      'Paid Amount': client.paid_amount,
      'Total Amount': client.total_amount,
      'Services': client.count_of_services,
      'Bookings': client.count_of_booking,
      'Cancelled': client.count_of_cancelled_booking,
      'Completed': client.count_of_completed_booking
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Clients");
    XLSX.writeFile(wb, 'ClientSummary.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "S.No", "Name", "Mobile No", "Email", "Location", "Country", "Referral",
      "Last Appointment", "Paid Amount", "Total Amount", "Services", "Bookings", "Cancelled", "Completed"
    ];
    const rows = paginatedClients.map((client, index) => [
      index + 1,
      client.name,
      client.mobile_no,
      client.email_id,
      client.address_location,
      client.country_name,
      client.customer_referal,
      formatDate(client.last_appointment_date),
      client.paid_amount,
      client.total_amount,
      client.count_of_services,
      client.count_of_booking,
      client.count_of_cancelled_booking,
      client.count_of_completed_booking
    ]);
    doc.autoTable({
      head: [columns],
      body: rows,
      theme: 'grid'
    });
    doc.save('ClientSummary.pdf');
  };

  return (
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Client Summary List</h2>
          <p className="mb-4 text-center">Overview of new, returning, and walk-in clients with appointments in the chosen timeframe.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClientSummary}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover className="text-center">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Profile Picture</th>
                <th>Client</th>
                <th>Mobile No</th>
                <th>Email ID</th>
                <th>Address Location</th>
                <th>Country</th>
                <th>Customer Referral</th>
                <th>Last Appointment Date</th>
                <th>Paid Amount</th>
                <th>Total Amount</th>
                <th>Count of Services</th>
                <th>Count of Booking</th>
                <th>Count of Cancelled Booking</th>
                <th>Count of Completed Booking</th>
              </tr>
            </thead>
            <tbody>
              {paginatedClients.length > 0 ? (
                paginatedClients.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td><img src={`${var_api}/${client.profile_image}`} alt="Profile" className="profile-image" width='65px' height='65px' /></td>
                    <td>{client.name}</td>
                    <td>{client.mobile_no}</td>
                    <td>{client.email_id}</td>
                    <td>{client.address_location}</td>
                    <td>{client.country_name}</td>
                    <td>{client.customer_referal}</td>
                    <td>{formatDate(client.last_appointment_date)}</td>
                    <td>{client.paid_amount}</td>
                    <td>{client.total_amount}</td>
                    <td>{client.count_of_services}</td>
                    <td>{client.count_of_booking}</td>
                    <td>{client.count_of_cancelled_booking}</td>
                    <td>{client.count_of_completed_booking}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between mt-4">
            <Button onClick={exportToPDF} variant="dark">Download as PDF</Button>
            <Button onClick={exportToExcel} variant="dark">Download as Excel</Button>
          </div>

          <Pagination className="justify-content-center mt-4">
            <Pagination.Prev onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
            {[...Array(totalPages).keys()].map((page) => (
              <Pagination.Item key={page} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} />
          </Pagination>
    </Container>
  );
};

export default ClientSummaryList;
